import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { CheckInCircleIcon } from "../../../images";

const Step = ({
  step,
  label,
  currentStep,
  setCurrentStep,
}: {
  step: number;
  label: string;
  currentStep: number;
  setCurrentStep: (step: number) => void;
}) => {
  return (
    <Stack flexDirection="row" gap="8px" alignItems="center">
      {currentStep > step ? (
        <Box onClick={() => setCurrentStep(step)} sx={{ cursor: "pointer" }}>
          <CheckInCircleIcon color="#0860A8" width="24px" height="24px" />
        </Box>
      ) : (
        <Typography
          component="span"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "24px",
            minWidth: "24px",
            borderRadius: "50%",
            height: "24px",
            color: "#FFFFFF",
            background: currentStep === step ? "#0860A8" : "#9E9E9E",
          }}
        >
          {step}
        </Typography>
      )}

      <Typography
        variant="button"
        color={currentStep >= step ? "text.primary" : "#9E9E9E"}
        fontWeight={currentStep >= step ? 500 : 400}
        lineHeight="14px"
      >
        {label}
      </Typography>
    </Stack>
  );
};

export const StepsBlock = ({
  currentStep,
  setCurrentStep,
}: {
  currentStep: number;
  setCurrentStep: (step: number) => void;
}) => {
  const steps = [
    { step: 1, label: "Upload Offering Info" },
    { step: 2, label: "Confirm & Customize" },
    { step: 3, label: "Set Industry, Geo and Size" },
    { step: 4, label: "Define Target Job Titles" },
    { step: 5, label: "Add Target Accounts" },
  ];

  return (
    <Stack
      flexDirection={{ xs: "row", md: "column" }}
      alignItems={{ xs: "center", md: "flex-start" }}
      flexWrap="wrap"
      gap="8px"
    >
      {steps.map(({ step, label }, index) => (
        <React.Fragment key={step}>
          <Step
            step={step}
            label={label}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
          {steps.length - 1 !== index && (
            <Box
              height="24px"
              width="1px"
              bgcolor="#CFCFCF"
              marginLeft="12px"
              display={{ xs: "none", md: "block" }}
            />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};
